module.exports = __webpack_public_path__ + "static/n6-1e376ad64afb1d1419e8fd39991dab12.jpg";